module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Home__main-container"
  }, [_c('div', {
    staticClass: "Home__header-sub"
  }, [_c('div', {
    staticClass: "Home__header-container"
  }, [_c('div', {
    staticClass: "Home__header-inner-container"
  }, [_c('div', {
    staticClass: "Home__header-info"
  }, [_c('div', {
    staticClass: "Home__header-info-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Home__header-icon-link"
  }), _vm._v("\n            " + _vm._s(_vm.user.conferenceUrl) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-info-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Home__header-icon-lock"
  }), _vm._v("\n            PIN " + _vm._s(_vm.user.conferencePin) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-actions"
  }, [_c('div', {
    staticClass: "Home__header-action",
    class: _vm.copyInfoClass,
    on: {
      "click": _vm.copyInfo
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.conferenceUrl),
      expression: "user.conferenceUrl"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "text",
      "id": "conference_url"
    },
    domProps: {
      "value": (_vm.user.conferenceUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "conferenceUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "Home__header-action--tranquil"
  }, [_vm._v("copy info")]), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_spinner Home__header-action--processing"
  }), _vm._v(" "), _c('span', {
    staticClass: "Home__header-action--termination"
  }, [_vm._v("copied")])]), _vm._v(" "), _c('div', {
    staticClass: "Home__header-action",
    class: {
      'active': _vm.subscription.active
    },
    on: {
      "click": _vm.toggleUpgradeMenu
    }
  }, [_vm._v("\n            " + _vm._s(_vm.subscription.active ? 'upgraded' : 'upgrade') + "\n          ")]), _vm._v(" "), _c('upgrade-dropdown', {
    attrs: {
      "is-open": _vm.showUpgradeMenu
    },
    on: {
      "update:isOpen": function($event) {
        _vm.showUpgradeMenu = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "Home__body"
  }, [_c('div', {
    staticClass: "Home__body-container"
  }, [_c('div', {
    staticClass: "Home__title"
  }, [_vm._v("\n        Welcome to Your Conference Room\n      ")]), _vm._v(" "), _c('img', {
    staticClass: "Home__logo-icon",
    attrs: {
      "src": require("../../../../static/images/logo-icon.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Home__main-actions"
  }, [_c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--blue",
    on: {
      "click": _vm.joinOwnRoom
    }
  }, [_vm._v("\n          enter my conference room\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.participantsCount) ? _c('div', {
    staticClass: "Home__waiting-count"
  }, [_c('i', {
    staticClass: "icon-ic_warning"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participantsCount) + " Participants Waiting in Your Conference Room")])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--green",
    on: {
      "click": _vm.joinRoom
    }
  }, [_vm._v("\n          join someone else's call\n        ")]), _vm._v(" "), (_vm.showBroadcasting) ? _c('a', {
    staticClass: "Home__main-action-btn Home__main-action-btn--red",
    on: {
      "click": _vm.startBroadcasting
    }
  }, [_vm._v("\n          start broadcasting\n        ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('join-room-modal'), _vm._v(" "), _c('start-broadcasting-modal'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": 'KingsConference - ' + _vm.user.username
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bceea26e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/home-tab/home-tab.vue
// module id = 434
// module chunks = 1